import {
  Provider,
  useActiveItem,
  useAddItem,
  useErrorCount,
  useFormRootPath,
  useItems,
  useRemoveItem,
  useSetActiveItem,
  useSyncWithLocation
} from './Provider';
import { BaseForm } from '@/components/ra-forms/LongForm/BaseForm';
import { Content } from '@/components/ra-forms/LongForm/Content';
import { Form } from '@/components/ra-forms/LongForm/Form';
import { NavMenu, NavMenuItem, useNavMenuItem } from '@/components/ra-forms/LongForm/NavMenu';
import {
  Sidebar,
  SidebarSection,
  SidebarSectionPosition,
  useSidebarChildren
} from '@/components/ra-forms/LongForm/Sidebar';
import { Group, Tab, useBaseItemChildren } from '@/components/ra-forms/LongForm/Tab';

type IForm = typeof Form & {
  BaseForm: typeof BaseForm;
  Content: typeof Content;
  Provider: typeof Provider;
  useItems: typeof useItems;
  useSyncWithLocation: typeof useSyncWithLocation;
  useErrorCount: typeof useErrorCount;
  useFormRootPath: typeof useFormRootPath;
  useActiveItem: typeof useActiveItem;
  useSetActiveItem: typeof useSetActiveItem;
  useAddItem: typeof useAddItem;
  useRemoveItem: typeof useRemoveItem;
  Sidebar: typeof Sidebar;
  SidebarSection: typeof SidebarSection;
  SidebarSectionPosition: typeof SidebarSectionPosition;
  useSidebarChildren: typeof useSidebarChildren;
  NavMenu: typeof NavMenu;
  NavMenuItem: typeof NavMenuItem;
  useNavMenuItem: typeof useNavMenuItem;
  Tab: typeof Tab;
  Group: typeof Group;
  useBaseItemChildren: typeof useBaseItemChildren;
};

const DefaultForm = Form as IForm;
DefaultForm.BaseForm = BaseForm;
DefaultForm.Content = Content;
DefaultForm.Provider = Provider;
DefaultForm.useItems = useItems;
DefaultForm.useSyncWithLocation = useSyncWithLocation;
DefaultForm.useErrorCount = useErrorCount;
DefaultForm.useFormRootPath = useFormRootPath;
DefaultForm.useActiveItem = useActiveItem;
DefaultForm.useSetActiveItem = useSetActiveItem;
DefaultForm.useAddItem = useAddItem;
DefaultForm.useRemoveItem = useRemoveItem;
DefaultForm.Sidebar = Sidebar;
DefaultForm.SidebarSection = SidebarSection;
DefaultForm.SidebarSectionPosition = SidebarSectionPosition;
DefaultForm.useSidebarChildren = useSidebarChildren;
DefaultForm.NavMenu = NavMenu;
DefaultForm.NavMenuItem = NavMenuItem;
DefaultForm.useNavMenuItem = useNavMenuItem;
DefaultForm.Tab = Tab;
DefaultForm.Group = Group;
DefaultForm.useBaseItemChildren = useBaseItemChildren;

export { DefaultForm as LongForm };
